import { ImageElement } from "@kontent-ai/gatsby-components";
import { ImageElementProps } from "@kontent-ai/gatsby-components/dist/image-element";
import React from "react";
import { transformImageUrl } from "@kontent-ai/delivery-sdk";
import { ImageFocalPoints } from "../../../types";
import AnimationWrapper, {
  AnimationBehaviors,
} from "../../containers/AnimationWrapper";

interface ImageProps extends ImageElementProps {
  focalPoint?: ImageFocalPoints;
  animation?: AnimationBehaviors;
}

export const KontentImageElement: React.FC<ImageProps> = ({
  animation,
  ...props
}) => {
  if (!props.image?.url) return null;

  if (props.focalPoint && props.focalPoint !== "center") {
    const focalPoints = props.focalPoint?.split("_");

    const y = focalPoints[0] === "bottom" ? 1.0 : 0.0;
    const x = focalPoints[1] === "right" ? 1.0 : 0.0;

    const src = transformImageUrl(props?.image?.url)
      .withAutomaticFormat()
      .withWidth(props.width || props.image.width)
      .withHeight(props.height || props.image.height)
      .withFocalPointCrop(x, y, 1.0)
      .withFitMode("crop")
      .getUrl();

    return <img src={src} alt={props.image?.description} />;
  }

  if (animation) {
    return (
      <AnimationWrapper behavior={animation}>
        <ImageElement {...props} />
      </AnimationWrapper>
    );
  }

  return <ImageElement {...props} />;
};
